module.exports = __webpack_public_path__ + "img/WW.d2743f2a.svg";